// Magic-link público: rastreia abertura do e-mail e redireciona para Portal Professor
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';

export default function NotifyRedirect() {
  const { lembreteId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('tracking'); // tracking | redirecting | error
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!lembreteId) return;
    (async () => {
      try {
        const res = await api.get(`/grade-engine/lembretes/${lembreteId}/track`);
        if (res.data?.success) {
          setInfo(res.data);
          setStatus('redirecting');
          setTimeout(() => {
            const tgt = res.data.deep_link || '/teacher-portal';
            // Se usuário não está logado, vai para login que redireciona
            navigate(tgt);
          }, 1500);
        } else {
          setStatus('error');
        }
      } catch (e) {
        setStatus('error');
      }
    })();
  }, [lembreteId, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-emerald-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-8 max-w-md w-full text-center">
        {status === 'tracking' && (
          <>
            <Loader2 className="w-12 h-12 text-purple-600 mx-auto animate-spin" />
            <h2 className="text-xl font-bold text-slate-800 mt-4">Validando notificação…</h2>
            <p className="text-sm text-slate-500 mt-2">Marcando como lida e redirecionando você.</p>
          </>
        )}
        {status === 'redirecting' && (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" />
            <h2 className="text-xl font-bold text-slate-800 mt-4">Olá, {info?.professor_nome}!</h2>
            <p className="text-sm text-slate-600 mt-2">
              Levando você para <strong>{info?.subject_name}</strong> · <strong>{info?.class_group_name}</strong>…
            </p>
            <div className="mt-4 h-1 bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-purple-600 to-emerald-500 animate-pulse" style={{ width: '100%' }} />
            </div>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto" />
            <h2 className="text-xl font-bold text-slate-800 mt-4">Notificação inválida ou expirada</h2>
            <p className="text-sm text-slate-500 mt-2">Por favor, abra o portal manualmente.</p>
            <button
              onClick={() => navigate('/v2/academico/portal-professor')}
              className="mt-4 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
            >
              Ir para o Portal
            </button>
          </>
        )}
      </div>
    </div>
  );
}
